import React from 'react'
import FormulaButton from '../formulaButton'
import UnitConverterForm from '../../container/unitConverterForm'

export default class UnitConverter extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Unit converter" iconName="unitConverter">
                    <UnitConverterForm />
                </FormulaButton>
            </div>
        )
    }
}